<template lang="pug">
.panel-page-white
  .panel-white.body-2.mx-auto
    PageHeader My Reports

    Datatable.mt-3(
      :columns="columns"
      :entries="data"
      :per-page="6"
    )
      template(slot-scope="props")
        tr
          td(v-if="props.entry.reportStatus === 'complete' && props.entry.reportType !== 'split_twins_report'")
            router-link(:to="reportRoute(props.entry.reportType, props.entry.id)") Complete
          td(v-if="props.entry.reportStatus === 'complete' && props.entry.reportType === 'split_twins_report'") Complete
          td(v-if="props.entry.reportStatus === 'pending'") Pending
          td(v-if="props.entry.reportStatus === 'error'").error Error
          td {{ humanReportType(props.entry.reportType) }}
          td {{ formatEpochTime(props.entry.createdAt) }}
          td {{ props.entry.reportStatus === 'pending' ? '' : formatEpochTime(props.entry.completedAt) }}
</template>

<script>
import axios from '@/lib/axios'
import PageHeader from '@/components/PageHeader'
import Datatable from '@/components/Datatable'
import { format } from 'date-fns/esm'

export default {
  name: 'MyReports',
  data() {
    return {
      data: [],
      columns: ['Status', 'Report Type', 'Started', 'Finished'],
    }
  },
  methods: {
    formatEpochTime(tm) {
      let date = new Date(0)
      date.setUTCSeconds(tm)
      return format(date, 'MM-dd-yyyy hh:mm aa')
    },
    humanReportType(rt) {
      switch (rt) {
        case 'transaction_summary':
          return 'Transaction Summary'
        case 'geoactivity':
          return 'Geo-Activity Report'
        case 'store_activity':
          return 'Store Activity Report'
        case 'transaction_id':
          return 'Receipt Transaction ID Lookup'
        case 'multiple_id':
          return 'Multiple ID Search'
        case 'split_by_id_updates':
          return 'Split by ID Updates'
        case 'split_by_bio_updates':
          return 'Split by BIO Updates'
        case 'split_twins_report':
          return 'Split Twins Updates'
      }
    },
    reportRoute(rt, id) {
      switch (rt) {
        case 'transaction_summary':
          return { name: 'transaction_summary_results1', params: { id } }
        case 'geoactivity':
          return { name: 'geo_activity_results', params: { id } }
        case 'store_activity':
          return { name: 'store_activity_report', params: { id } }
        case 'transaction_id':
          return { name: 'transaction_results', params: { id } }
        case 'multiple_id':
          return { name: 'multiple_id_results', params: { id } }
        case 'split_by_id_updates':
          return { name: 'split_by_id_updates', params: { id } }
        case 'split_by_bio_updates':
          return { name: 'split_by_bio_updates', params: { id } }
        case 'split_twins_report':
          return { name: 'split_twins_report', params: { id } }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    axios()
      .get('/api/reports')
      .then(resp => {
        next(vm => (vm.data = resp.data))
      })
      .catch(err => {})
  },
  components: { PageHeader, Datatable },
}
</script>

<style lang="scss" scoped>
.error {
  color: red;
}
</style>
